export default {
      id: "student-guide-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#student-guide",
      toString: function () {
        return this.url;
      }
    }